function initImageSlider() {
    const imageSliders = document.querySelectorAll(".image-slider");
    if (!imageSliders) return;

    imageSliders.forEach((imageSlider) => {
        const elId = imageSlider.getAttribute("id");

        initSwiper(elId);
    });

    function initSwiper(id) {
        const slides = document.querySelectorAll(`#${id} .image-slider__slide`);

        if (!slides) return;

        const swiper = new Swiper(`#${id} .image-slider__swiper.swiper`, {
            slidesPerView: 1.2,
            spaceBetween: 12,
            centerInsufficientSlides: true,
            loop: true,
            freeMode: true,
            autoplay: {
                delay: 3000,
            },
            breakpoints: {
                750: {
                    slidesPerView: 2.5,
                    spaceBetween: 16,
                },
                990: {
                    slidesPerView: 3.5,
                    spaceBetween: 24,
                },
            },
        });

        return swiper;
    }
}

document.addEventListener("DOMContentLoaded", () => {
    initImageSlider();
});
